let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("4nUBB")), load("756Sk")]).then(() => parcelRequire('5SP4f'));